import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@evergis/ui";

import { CheckboxContainer } from "../styled";
import { RequestDependencyInfo, RequestInfoType } from "./RequestInfo";
import { ResourcesResolved } from "../resolveResources";
import { DeleteResourcesContentProps } from "../types";

type DeleteTablesContentProps = Pick<DeleteResourcesContentProps, "checked" | "toggle"> & ResourcesResolved;

export const DeleteTablesContent: FC<DeleteTablesContentProps> = ({ projects, layers, tables, checked, toggle }) => {
  const { t } = useTranslation("dialogs");
  const showSourceCheckbox = tables.length > 0;

  return (
    <>
      {showSourceCheckbox && (
        <>
          <CheckboxContainer>
            <Checkbox
              checked={checked.layers}
              label={t("deleteResources.deleteDataSourceLayers")}
              onChange={toggle.layers}
            />
          </CheckboxContainer>
          <RequestDependencyInfo
            type={RequestInfoType.LayersWithTables}
            projects={projects}
            layers={layers}
            tables={tables}
          />
        </>
      )}
    </>
  );
};
